// i18n area 'cluster' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.tr-TR.meta.json.
import type { enUS } from './cluster'

export const trTR: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garanti erişimleri',
      subtitle: 'Düğümün servis kapısı: geçici parolalı salt okunur erişim ve kasa parolalı acil durum hesabı',
      readOnlyTitle: 'Salt okunur erişim (trantor)',
      stateNone: 'kapalı',
      stateGranted: 'açık',
      stateGrantedPending: 'verildi — düğümde uygulanıyor',
      grantedBy: 'Veren',
      grantedAt: 'Verilme tarihi',
      expiresAt: 'Bitiş tarihi',
      reason: 'Gerekçe',
      endedAt: 'Kapalı',
      endedReason: {
        revoked: 'iptal edildi',
        expired: 'süresi doldu (TTL)',
        reboot: 'düğümün yeniden başlatılması',
        failed: 'uygulanmadı (görev başarısız)'
      },
      grant: 'Salt okunur erişim ver…',
      grantTitle: 'Salt okunur erişim ver',
      grantSubmit: 'Ver',
      grantError: 'Erişim verme reddedildi',
      grantConfirm: 'TVirt, «trantor» sistem kullanıcısı için geçici bir parola üretir (salt okunur: journal ve tanılama, sudo yok) ve bir görevle düğüme ayarlar. Parola YALNIZCA bir kez, onayda gösterilir; süre dolduğunda, iptal edildiğinde veya düğümün bir sonraki yeniden başlatılmasında sona erer.',
      reasonLabel: 'Gerekçe',
      reasonHint: 'Kapıyı neden açıyorsunuz: erişim kaydında, denetimde ve günlükte yer alır',
      ttlLabel: 'Süre',
      ttlHours: '{n} sa',
      revoke: 'Salt okunur erişimi iptal et…',
      revokeTitle: 'Salt okunur erişimi iptal et',
      revokeSubmit: 'İptal et',
      revokeError: 'İptal reddedildi',
      revokeConfirm: 'Erişim hemen sona erer ve bir görev «trantor» kullanıcısını düğümde yeniden kilitler: geçici parola geçerliliğini yitirir.',
      passwordTitle: 'Salt okunur parola',
      passwordOnce: 'Bu parola YALNIZCA bir kez gösterilir: şimdi kopyalayın. Hiçbir yerde saklanmaz ve yeniden okunamaz — kaybederseniz yeniden erişim verin.',
      passwordUser: 'Kullanıcı',
      passwordLabel: 'Parola',
      passwordHint: '{until} tarihine veya düğümün bir sonraki yeniden başlatılmasına kadar geçerlidir; erişim görevi tamamlandığında kullanılabilir. Erişim: ssh trantor@<düğüm adresi>.',
      emergencyTitle: 'Son acil durum erişimi (trantor-emergency)',
      lastLogin: '{time}, {via} üzerinden, {from} adresinden',
      lastLoginNone: 'gözlemlenmedi',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsol',
        sudo: 'sudo',
        unknown: 'bilinmiyor'
      },
      emergencyHint: '«trantor-emergency» acil durum hesabı (tam sudo), düğümün kurulumunda üretilip kasada saklanan parolayla her zaman etkindir: TVirt onu bilmez, döndürmez ve kurtarmaz. Her oturum açma burada ve olay günlüğünde bildirilir.'
    },
    nodeFirewall: {
      tab: 'Güvenlik duvarı',
      title: 'Düğüm güvenlik duvarı',
      subtitle: 'Her düğümün kendisine uyguladığı nftables ruleset’inin duruşu — bir düğümün tek güvenlik duvarı (firewalld devre dışıdır)',
      modeLabel: 'Duruş',
      mode: {
        disabled: 'Devre dışı — düğümlerde ruleset yok',
        permissive: 'İzinli — sayar ve kaydeder, hiçbir şeyi düşürmez',
        enforced: 'Uygulanmış — yalnızca türetilmiş kayıt defteri içeri girer'
      },
      hint: {
        disabled: 'Bugünkü gibi: düğümler hiçbir ruleset taşımıyor. Neyin düşürüleceğini düşürülmeden önce OKUMAK için izinli moda geçin.',
        permissive: 'Her düğüm kendi türetilmiş ruleset’ini policy accept ile uygular: uygulanmış modun düşüreceği şey sayılır ve kaydedilir (journal öneki «tvirt-node would-drop:»). Hiçbir şey engellenmez.',
        enforced: 'Her düğüm kendi türetilmiş ruleset’ini policy drop ile uygular: ssh ve API her yerden, store / live migration / overlay / Ceph yalnızca üyelerden, ağ hizmetlerinin listener’ları hizmet verdikleri ağdan. Her geçiş onaylı bir apply’dır — onaylayamayan bir düğüm kendiliğinden geri döner.'
      },
      confirmTitle: 'Düğüm güvenlik duvarı uygulansın mı?',
      confirmBody: 'Her düğüm ruleset’i onayla uygular: süre dolmadan yeni kurallar üzerinden backend’i, store’u ve ssh’yi yoklar ve onaylar — aksi halde kendiliğinden önceki ruleset’e geri döner. Önce düğümlerdeki izinli mod sayaçlarını okuyun.',
      confirmSubmit: 'Uygula',
      confirmCancel: 'İptal',
      lensTitle: 'Düğümün güvenlik duvarı',
      loadError: 'Düğümün güvenlik duvarı merceği yüklenemedi',
      noReport: 'Bu düğümden henüz güvenlik duvarı raporu yok — worker bir sonraki turda bildirir',
      firewalldActive: 'Bu düğümde firewalld çalışıyor: düğüm güvenlik duvarı onun yanında uygulanmayı reddeder (firewalld’yi maskeleyin)',
      conditionUnconfirmed: 'Henüz onaylanmış ruleset yok — düğüm açık',
      conditionRolledBack: 'Son apply geri döndü — kayıt defteri değişene veya duruş yeniden değiştirilene kadar aynı nesil yeniden denenmez',
      lastError: 'Son hata',
      posture: 'Duruş',
      observedAt: 'Gözlemlendi',
      desiredGeneration: 'İstenen nesil',
      componentTitle: 'Düğüm bileşeni',
      componentSubtitle: 'tvirt-node-firewall — onaylanmış ruleset’i boot’ta uygular, onaylanmamış olanı kendiliğinden geri alır',
      componentAbsent: 'Bileşen henüz bildirimde bulunmadı',
      phase: 'Aşama',
      phases: {
        none: 'Hiç uygulanmadı',
        applied: 'Uygulandı — onay bekleniyor',
        confirmed: 'Onaylandı',
        rolledBack: 'Geri döndü'
      },
      generation: 'Nesil',
      appliedAt: 'Uygulanma zamanı',
      confirmedAt: 'Onaylanma zamanı',
      deadline: 'Rollback zaman sınırı',
      lastRollback: 'Son rollback',
      registryTitle: 'Türetilmiş kayıt defteri',
      registrySubtitle: 'Bu düğümün açtığı portlar, sınıf ve kökene göre — kümeden türetilir, asla elle düzenlenmez',
      registryEmpty: 'Türetilmiş bir şey yok — onaylanmış ruleset olmadan devre dışı duruş, ya da henüz rapor yok',
      colClass: 'Sınıf',
      colPort: 'Port',
      colSource: 'Kaynak',
      colOrigin: 'Köken',
      classes: {
        public: 'Genel',
        internode: 'Düğümler arası',
        tenant: 'Tenant'
      },
      sourceMembers: 'yalnızca üyeler',
      sourceAnywhere: 'her yerden',
      sourceBridge: '{iface} üzerinde'
    },
    derivationDerived: 'türetilmiş',
    derivationDiverged: 'sapmış',
    derivationDerivedTip: 'Ağ belgesi {fabric} fabric\'inden TÜRETİLMİŞ ve mevcut girdilerde hâlâ render ile örtüşüyor — türetme planı için tıklayın.',
    derivationDivergedTip: '{fabric} fabric\'inden türetme son apply\'dan sonra değişti (fabric, kablolama, roller veya referanslar) — bekleyen diff için tıklayın.',
    derivationRetiring: {
      one: '{n} adres boşaltılıyor',
      other: '{n} adres boşaltılıyor'
    },
    standaloneHint: "Bu düğümün bir kümesi yok: henüz kurulmamış. Kümeler kurulum sırasında oluşturulur VEYA join edilir — bir üyenin Sunucular tablosundan üretilen token installer'a verilir (dev: db:init-cluster / db:init-join).",
    reducedHint: "İzinleriniz tüm kümeyi değil bir scope'u kapsıyor: filo envanteri — düğümler, ayarlar ve aygıtlar — yalnızca küme yöneticilerine görünür.",
    phaseReady: 'Hazır',
    phaseForming: 'Oluşum aşamasında',
    storeMembers: 'Store üyeleri',
    watermark: 'Yakınsama eşiği',
    configGeneration: 'Config nesli',
    converged: 'yakınsamış',
    behind: 'geride — {m} / {n}',
    revision: 'Revizyon',
    rolesTitle: 'Ağ rolleri',
    rolesSubtitle: 'Her trafik sınıfı için üye başına adresler — bağlantının kendisi host ağındadır',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: "management'ı devralır",
    settingsTitle: 'Ayarlar',
    settingsSubtitle: 'Küme genelinde güvenlik policy\'si — her düğüm tarafından kendi yerel replikasından değerlendirilir',
    taskRetentionTitle: 'Görev saklama',
    taskRetentionSubtitle: 'Tüm görevler için birleşik GC — yaşı veya üst sınırı aşan bitmiş görevler toplanır, devam edenler asla',
    taskRetentionMaxAge: 'Maksimum yaş (gün)',
    taskRetentionMaxCount: 'Maksimum görev sayısı',
    eventRetentionTitle: 'Olay saklama',
    eventRetentionSubtitle: "Günlüğün GC'si — görevlerinkinden bağımsız bir politika: görev bir kuyruktur, olay bellektir",
    eventRetentionMaxAge: 'En fazla yaş (gün)',
    eventRetentionMaxCount: 'Saklanan en fazla olay sayısı',
    spaceThresholdsTitle: 'Alan eşikleri',
    spaceThresholdsSubtitle: 'Dolan bir depolamanın günlüğe (ve bildirimlere) ne zaman girdiği',
    spaceLowPct: 'Uyarı şu değerden (% kullanılan)',
    spaceCriticalPct: 'Kritik şu değerden (% kullanılan)',
    spaceOrderError: 'Kritik, uyarının altında olamaz',
    spaceThresholdsHint: 'Yalnızca girişler yapılandırılır: çıkışı motor türetir, her eşiğin 5 puan altında, böylece çizgi üzerinde duran bir depolama asla metronoma dönüşmez',
    failoverReserveTitle: 'Yük devretme rezervi',
    failoverReserveSubtitle: 'Admission control N+1 — düğüm kayıplarından sonra kümenin kendi iş yükünü yeniden başlatabilmesi için boş tutulan RAM',
    failoverReserveTolerate: 'Kaybı tolere edilecek düğüm sayısı',
    failoverReserveOff: '0 — rezerv kapalı: hiçbir başlatma yük devretme kapasitesi nedeniyle reddedilmez',
    failoverReserveOn: 'Rezervi aşındıracak bir başlatma, sayıları açıklayan bir 412 ile reddedilir',
    networkShapingTitle: 'Bant genişliği adaleti',
    networkShapingSubtitle: 'Uplink başına shaping ağacının üç tipoloji ağırlığı — yalnızca çekişme altında etki eder',
    networkShapingRest: 'Kalanın ağırlığı (kontrol düzlemi, storage, replikalar)',
    networkShapingOverlay: 'Overlay ağlarının ağırlığı',
    networkShapingLiveMigration: 'Live migration ağırlığı',
    networkShapingHint: 'Garantili pay = ağırlık / üçünün toplamı (varsayılan 300 / 100 / 200, her biri 1 ile 10000 arası); boş bir bağlantıda her sınıf tüm bant genişliğini alabilir',
    debugModeTitle: 'Debug modu',
    debugModeSubtitle:
      "GUI'nin genel uyarılarındaki ayrıntılı hatalar — “başarısız” bir eylem aslında başarılı olduğunda gerçek nedeni görmek için",
    debugModeLabel: 'Debug modu etkin',
    debugModeOn: 'Genel hata uyarıları altta yatan nedeni ekler — iç ayrıntılar her operatöre görünür',
    debugModeOffHint: 'Kapalı — genel hata uyarıları genel kalır, iç ayrıntı olmadan',
    nodeDetailsAction: 'Düğüm ayrıntıları',
    node: {
      docTitle: 'Düğüm',
      notFound: 'Düğüm bulunamadı',
      tabOverview: 'Genel bakış',
      tabStats: 'İstatistikler',
      tabNetwork: 'Ağ',
      tabSettings: 'Yerel ayarlar',
      identityTitle: 'Kimlik',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL portu',
      revision: 'Config revizyonu',
      versionsTitle: 'Gözlemlenen sürümler',
      heartbeatSubtitle: 'Düğümün kendisi hakkında bildirdiği son durum',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU modeli',
      memoryTitle: 'Bellek',
      hugePagesTitle: 'Büyük sayfalar',
      hugePagesPool: '{size}: {total} içinden {free} boş',
      hugePagesNone: 'Havuz yok',
      hugePagesNoneHint: "Düğümde ayrılmış büyük sayfa yok: bunları isteyen VM'ler burada başlatılamaz. Havuz, kernel'in hugepagesz ve hugepages parametreleriyle ya da nr_hugepages yazılarak düğümde bildirilir.",
      usageTitle: 'Mevcut kullanım',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'gözlemlenmedi — taze örnek yok',
      statsNoData: 'Seçilen aralıkta veri yok — düğüm serileri düğümün kendisi tarafından örneklenir ve yerelden sunulur.',
      observedTitle: 'Gözlemlenen durum',
      observedSubtitle: "Hizmetler ve düğüme yerel asset'ler, worker'ın gördüğü şekliyle"
    },
    editRolesTitle: 'Ağ rollerini düzenle',
    memberNode: 'Düğüm',
    memberIp: 'IP adresi',
    addMember: 'Üye ekle',
    lmInherit: 'Management adreslerini kullan',
    roleIpHint: "Üye eklemek ve kaldırmak serbesttir; mevcut bir üyenin IP'sini yerinde değiştirmek reddedilir — IP geçiş akışı sonraki bir round'da gelecek.",
    roleError: 'Roller güncellenemedi',
    nodesTitle: 'Düğümler',
    addNodeTitle: 'Kümeye düğüm ekle',
    addNode: 'Düğüm ekle',
    addNodeError: 'Düğümün ön kaydı yapılamadı',
    nodeName: 'Düğüm adı',
    nodeNameHint: 'kurulumda seçilen adla eşleşmelidir',
    nodeIp: "Management IP'si",
    colName: 'Ad',
    colPhase: 'Aşama',
    colServices: 'Hizmetler',
    colWatermark: 'Watermark',
    colLastSeen: 'Son görülme',
    colUps: 'UPS',
    upsCordonChip: 'UPS kordonu',
    upsCordonTip: 'Düğüm kendi UPS gerçeklerine dayanarak kendini mahkûm etti ({time}): şebeke kararlı olup pil dolunca kordonu kendisi kaldırır',
    upsUnreachable: 'UPS erişilemez',
    upsOnBattery: 'Pilde',
    upsOnLine: 'Şebekede',
    upsLowBattery: 'pil zayıf',
    upsNoEstimateChip: 'kalan süre tahmin edilmedi',
    upsNoEstimateTip: 'UPS kalan süre tahmini yayınlamıyor: düğüm yalnızca UPS’in LB (pil zayıf) bayrağıyla mahkûm edilir — battery.runtime.low / LB’yi UPS üzerinde ayarlayın',
    upsLaneTip: '{since} tarihinden beri UPS kapatma yolu: {by} nedeniyle mahkûm',
    upsUnit: 'birim',
    upsStatus: 'NUT durumu',
    upsLoad: 'yük',
    upsOnBatterySince: 'şu tarihten beri pilde',
    upsOnLineSince: 'şu tarihten beri şebekede',
    upsError: 'hata',
    upsObservedAt: 'gözlemlendi',
    upsNone: 'bu düğüme hizmet veren UPS birimi yok',
    upsBy: {
      runtime: 'kalan süre eşiğin altında',
      lowBattery: 'UPS’in LB bayrağı',
    },
    upsLane: {
      evacuate: 'tahliye',
      local: 'yerinde kapatma',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'konuklar durduruluyor',
      stoppingServices: 'hizmetler durduruluyor',
      poweredOff: 'kapalı',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS birimleri ve eşikler: düğüm kalan süre ≤ eşik veya LB bayrağında (her zaman dikkate alınır) mahkûm edilir, histerezisle devam',
    upsRuntimeThreshold: 'Kalan süre eşiği (s)',
    upsRuntimeThresholdHint: 'Pilde, tahmini kalan süre ≤ eşik iken düğüm sırayla kapanır (varsayılan 300)',
    upsResumeStable: 'Şebeke kararlı süresi (s)',
    upsResumeStableHint: 'Yalnızca en az bu kadar saniyedir kesintisiz şebekeyle devam (varsayılan 60)',
    upsResumeCharge: 'Devamda asgari şarj (%)',
    upsResumeChargeHint: 'Ve pil en az bu yüzdeye kadar dolmuş olmalı (varsayılan 25)',
    upsPolicyNote: 'UPS’in LB (pil zayıf) bayrağı her zaman mahkûm eder ve kapatılamaz; pilde geçen süre için eşik yoktur. Her birim üç sayıyı geçersiz kılabilir.',
    upsUnitNew: 'yeni birim',
    upsUnitSelectors: '{n} etiket seçici (yalnızca CLI)',
    upsUnitName: 'Birim adı',
    upsUnitMode: 'Mod',
    upsModeExternal: 'harici (başkasının upsd’si)',
    upsModeManaged: 'yönetilen (bir düğüme bağlı UPS)',
    upsUnitUpsname: 'NUT adı (upsname)',
    upsUnitHost: 'upsd ana bilgisayarı',
    upsUnitAttachedNode: 'Bağlı düğüm',
    upsUnitDriver: 'NUT sürücüsü',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Sürücünün aygıtı',
    upsUnitDeviceHint: 'ups.conf içindeki port= satırı: boş = auto',
    upsUnitPort: 'upsd portu',
    upsUnitServedNodes: 'Hizmet verilen düğümler',
    upsUnitServedNodesHint: 'virgülle ayrılmış düğüm adları (etiket seçiciler CLI üzerinden)',
    upsUnitOverrideHint: 'boş = küme varsayılanı',
    upsUnitAdd: 'Birim ekle',
    unreachableSince: 'Erişilemiyor — son heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: "Overlay dataplane'i geçerli overlay yapılandırmasını henüz gerçekleştirmedi",
    overlaysError: "Son overlay uzlaştırma pass'i başarısız oldu: {error}",
    storeChip: 'store',
    phase: {
      'pending-join': 'Join bekleniyor',
      'joining': 'Katılıyor',
      'member': 'Üye'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Yalnızca şimdi gösteriliyor — hemen kopyalayın, bir daha asla okunamayacak',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    close: 'Kapat',
    revokeTitle: 'Ön kaydı geçersiz kıl',
    revoke: 'Geçersiz kıl',
    revokeError: 'Kayıt geçersiz kılınamadı',
    promote: 'Store üyesine yükselt',
    demote: 'Store-member rolünü kaldır',
    troubleshoot: 'Sorun giderme',
    promoteTitle: 'Store üyesine yükselt',
    demoteTitle: 'Store-member rolünü kaldır',
    promoteHint: "Düğüm, YugabyteDB master quorum'una katılır. Gerçek HA üç store üyesi gerektirir.",
    demoteHint: "Düğüm master quorum'undan çıkar ve store hizmetlerini durdurur.",
    storeError: 'Store-member değişikliği reddedildi',
    attest: 'Kapalı beyan et…',
    attestTitle: 'Düğümü kapalı beyan et',
    attestSubmit: 'Kapalı beyan et',
    attestConfirm: "Bu düğümü, riski size ait olmak üzere kapalı olarak bildiriyorsunuz: aslında çalışan bir düğümü kapalı beyan etmek, VM'lerin çift çalışması riskini doğurur. Düğümün görevleri başarısız sayılır ve VM'lerinin authority'leri devredilebilir hale gelir.",
    attestError: 'Beyan reddedildi',
    attestedChip: 'kapalı beyan edildi',
    maintenanceChip: 'bakım',
    guestToolsChip: "TVirt Guest Tools (düğüme yerel ISO asset'i)",
    maintenanceEnter: 'Bakıma al',
    maintenanceExit: 'Bakımdan çıkar',
    maintenanceEnterTitle: 'Bakıma al',
    maintenanceExitTitle: 'Bakımdan çıkar',
    maintenanceEnterSubmit: 'Bakıma al',
    maintenanceExitSubmit: 'Bakımdan çıkar',
    maintenanceEnterConfirm: "Düğüm kordona alınır ve boşaltılır: authority'sini tuttuğu ağ hizmetleri ve App örnekleri aktarılır (örnekler soğuk: burada durdurulup biçilir, hedef düğümde yeniden oluşturulur — kesinti), çalışan VM'ler mümkün olan yerde canlı taşınır, aksi halde düzgünce durdurulur, süren görevler biter, yeni iş bekletilir ve durdurulan VM'ler authority'lerini kaybeder — Proximity bir sonraki başlatmada onları yeniden yerleştirir. Bakım bitince hiçbir şey kendiliğinden geri gelmez.",
    maintenanceExitConfirm: "Düğüm yeniden iş almaya başlar ve Proximity yerleştirme için onu yeniden değerlendirir. VM'ler yalnızca başlatıldıklarında geri döner.",
    maintenanceError: 'Bakım isteği reddedildi',
    maintenancePlanTitle: 'Boşaltma planı',
    maintenancePlanLoading: 'Boşaltma planı hesaplanıyor…',
    maintenancePlanError: "Boşaltma planı yüklenemedi — boşaltma yine de mümkün olan VM'leri geçirecek ve kalanları durduracak.",
    maintenancePlanEmpty: 'Bu düğümde tahliye edilecek bir şey yok — etkin ağ hizmeti yok, çalışması istenen App örneği yok, çalışan VM yok.',
    maintenancePlanSummary: "{migrate} nesne taşınacak (VM'ler, ağ hizmetleri, App örnekleri), {stop} duracak ya da olduğu yerde kalacak.",
    maintenancePlanReserve_ok: 'Boşaltma sonrası yük devretme rezervi: sağlam — {n} düğüm kaybı tolere edilirken başlatılabilir {headroom} GiB kalıyor.',
    maintenancePlanReserve_eroded: "Boşaltma sonrası yük devretme rezervi: neredeyse tükendi — {n} düğüm arızası için boş tutulan {reserve} GiB'in yalnızca {headroom} GiB'i kaldı.",
    maintenancePlanReserve_exhausted: "Boşaltma sonrası yük devretme rezervi: TÜKENDİ — {n} düğüm arızasını tolere etmek için gereken {reserve} GiB'in {headroom} GiB'i eksik. Bu düğüm devre dışıyken yeni VM başlatmaları reddedilecek.",
    maintenancePlanReserve_unknown: 'Boşaltma sonrası yük devretme rezervi: hesaplanamıyor — kalan hiçbir düğüm belleğini bildirmedi.',
    maintenancePlanReserveHugePages: 'Boşaltma sonrası {size} büyük sayfalar — boş: {capacity} içinden {free}, rezerv olarak gereken: {reserve}.',
    maintenancePlanActionMigrate: 'geçirilir',
    maintenancePlanActionMigrateWarning: 'geçirilir (soft kural ihlal edildi)',
    maintenancePlanActionStop: 'durdurulur',
    maintenancePlanActionBlocked: 'engellendi',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'ağ hizmeti',
    maintenancePlanKindApp: 'App örneği',
    maintenancePlanColdMove: "Soğuk taşıma: pod burada durdurulup biçilir ve hedef düğümde onun worker'ı tarafından yeniden oluşturulur — hedef worker'ın bir sonraki pass'ine kadar kesinti.",
    caFingerprint: "Küme CA fingerprint'i",
    staleChip: 'güncel değil',
    troubleshootTitle: 'Store sorun giderme',
    restartStore: 'Store hizmetlerini yeniden başlat',
    restartHint: 'Store huysuzluk yapıyorsa hizmetlerini yeniden başlatın. Gelişmiş — dikkatle kullanın.',
    restartQueued: 'Yeniden başlatma görevi kuyruğa alındı',
    restartError: 'Hizmetler yeniden başlatılamadı',
    svcActive: 'etkin',
    svcWanted: 'istenen, çalışmıyor',
    svcStopped: 'durmuş',
    noServices: 'Bildirilen hizmet yok'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Modele göre gruplanmış küme geneli GPU envanteri — düğüm başına gözlemlenen kartlar, işaretli kayıtlar ve etiketleriyle birlikte',
    usbTitle: 'USB kaynakları',
    usbSubtitle: 'Modele göre gruplanmış küme geneli USB envanteri — düğüm başına gözlemlenen aygıtlar, her iki modelin kayıtları (aygıta göre, porta göre) ve etiketleriyle birlikte',
    markedChip: '{n} TVirt tarafından kullanılabilir',
    orphanChipGpu: '{n} sahipsiz',
    orphanChipUsb: '{n} sahipsiz',
    colNode: 'Düğüm',
    colRegistration: 'Kayıt',
      noRegsHint: 'Henüz kayıt yok — aygıt, düğümün dialog\'unda "TVirt tarafından kullanılabilir" olarak işaretlenir (Düğümler › düğüm › Ayarlar).',
      colDevice: 'Aygıt',
      colObserved: 'Gözlemlenen',
      colRegs: 'Kayıtlar',
      regsNone: 'yok',
      colPci: 'PCIe adresi',
      colIdentity: 'Kimlik / port',
      colClasses: 'Sınıflar (etiketler)',
      colActions: 'Eylemler',
      manageOnNode: "{node} düğümünde yönet (işaretleme düğümün dialog'undadır)",
      introTitle: 'TVirt© tarafından kullanılabilir USB ve PCIe aygıtlarının küme geneli envanteri.',
      introStep1: "1. Düğümler GPU'larını ve USB aygıtlarını kendiliğinden keşfeder (heartbeat sayımı).",
      introStep2: '2. Bir aygıt, DÜĞÜM dialog\'undan "TVirt tarafından kullanılabilir" olarak işaretlenir (Düğümler › düğüm › Ayarlar) — işaretleme onu vfio\'ya bağlar ve buraya kaydeder.',
      introStep3: '3. Kayıtlara SINIFLARINI burada etiketler aracılığıyla verirsiniz (örn. gpu_class=compute): VM gereksinimleri bir sınıf isteyecek ve scheduler boş, uyumlu bir aygıtı olan bir düğüm seçecek.',
    colMode: 'Mod',
    colState: 'Durum',
    colNotes: 'Notlar',
    colTags: 'Etiketler',
    modeDevice: 'aygıta göre',
    modePort: 'porta göre',
    usable: 'kullanılabilir',
    orphanGpu: 'sahipsiz',
    orphanUsb: 'sahipsiz',
    hubChip: 'hub',
    orphanPortsTitle: 'Takılı aygıtı olmayan port kayıtları — bir aygıt yeniden takın ya da işaretlerini düğümden kaldırın',
    gpusEmpty: 'Henüz hiçbir düğümde GPU gözlemlenmedi',
    usbEmpty: 'Henüz hiçbir düğümde USB aygıtı gözlemlenmedi'
  },

  // Ayarlar formlarının ortak sözlüğü (settings refactor, 2026-07-24).
  settings: {
    passwordMinLength: 'Minimum parola uzunluğu',
    sessionIdle: 'Oturum boşta kalma zaman aşımı (dakika)',
    lockoutThreshold: 'Başarısız denemelerden sonra kilitleme',
    lockoutDuration: 'Kilitleme süresi (dakika)',
    keyboardLayout: 'Klavye düzeni',
    keyboardLayoutHint: 'örn. it, en-us — QEMU varsayılanı için boş bırakın',
    syslogEndpoint: "Syslog endpoint'i",
    syslogEndpointHint: 'host:port — iletmeyi devre dışı bırakmak için boş bırakın',
    syslogTls: 'TLS',
    maxQueued: 'Kuyruktaki maksimum görev',
    concurrency: 'Worker eşzamanlılığı',
    concurrencyHint: 'Worker tarafından anında uygulanır',
    notesTitle: 'Notlar',
    save: 'Kaydet',
    saved: 'Ayarlar kaydedildi',
    saveError: 'Ayarlar kaydedilemedi'
  },
  localSettings: {
    derivedChip: 'türetilmiş',
    derivedTip: 'Bu device fabric türetmesinin MÜLKÜ (H2): editör ona dokunmayı reddediyor — fabric\'i (veya kablolamayı) değiştirin ve yeniden uygulayın, ya da aşağıda geri alın.',
    takeOwnership: 'Sahipliği al',
    takeOwnershipTitle: 'Sahipliği al (take-ownership)',
    takeOwnershipConfirm: '{name} fabric bloğundan çıkar ve yeniden bu editörün yönettiği MANUEL bir device olur. Node sapmış olur ve bir sonraki türetme apply\'ı onda reddeder (manualConflict), siz onu yeniden adlandırana veya kaldırana kadar — ya da fabric\'i düzeltene kadar.',
    nodeSettingsTitle: 'Düğüm ayarları',
    nodeSettingsSubtitle: 'Bu düğümün uyguladıkları — görev kuyruğu, konsol, günlük iletme — artı etiketleri ve notları',
    baseTitle: 'Host rezervleri (TVirt Proximity)',
    baseSubtitle: "Host işletim sistemine ayrılan CPU ve RAM — Proximity'nin VM'leri yerleştirirken kullandığı deneysel kapasitenin girdileri",
    baseMemory: 'Temel RAM (MiB)',
    baseMemoryHint: "Gözlemlenen toplam: {total} MiB. VM'ler için kullanılabilir = toplam − temel − buraya yerleştirilmiş açık VM'lerin RAM'i.",
    baseMemoryHintNoTotal: "VM'ler için kullanılabilir = gözlemlenen toplam − temel − buraya yerleştirilmiş açık VM'lerin RAM'i.",
    baseCpu: 'Temel CPU çekirdekleri',
    baseCpuHint: "Gözlemlenen mantıksal CPU'lar: {total}. Yalnızca sıralama ağırlığı olarak kullanılır — vCPU overcommit'i normaldir.",
    baseCpuHintNoTotal: "Yalnızca sıralama ağırlığı olarak kullanılır — vCPU overcommit'i normaldir.",
    baseHint: "RAM, katı kabul gate'idir: kullanılabilir RAM'e sığmayan bir VM, açıklayıcı bir hatayla reddedilir. Store üyeleri veya Ceph daemon'ları barındıran hostlarda temeli yükseltin.",
    placementTitle: 'Fiziksel yerleşim',
    placementSubtitle: 'Bu sunucunun fiziksel olarak durduğu yer — ne işe hizmet ederse etsin, bir kez bildirilir',
    placementHint: "Yerleşim, bu sunucuda OSD'si olan her Ceph kümesinin CRUSH hiyerarşisini yönlendirir: bir değişikliği kaydetmek, haritalarını bir görev aracılığıyla yeniden hizalar (host → rack → … → root). Kısmi bildirimler geçerlidir — boş seviyeler yalnızca atlanır. Adlar tüm harita genelinde paylaşılır: aynı rack'teki iki sunucu aynı rack adını bildirir.",
    placementNameInvalid: 'DNS-safe ad (küçük harfler, rakamlar, tireler)',
    placementEmpty: 'Boş = bildirilmedi',
    placementLevel: {
      chassis: 'Kasa',
      rack: 'Rack',
      row: 'Sıra',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Oda',
      datacenter: 'Datacenter',
      zone: 'Alan',
      region: 'Bölge'
    },
    cablingTitle: 'Kablolama',
    cablingSubtitle: 'Her arabirimin anahtarın hangi portuna takılı olduğu — bildirim düğümde tutulur (Annex O.9)',
    cablingHint: 'NIC başına bir kablo, filo genelinde port başına bir kablo (API, sahibini adlandırarak reddeder). LAGG üyesi bir porta kablolamak geçerlidir — bu bond durumudur: gelecekteki türetme bunu LACP olarak işleyecek.',
    cablingInterface: 'Arabirim',
    cablingNotCabled: '— kablolanmadı —',
    cablingNoInterfaces: 'Henüz gözlemlenen ağ arabirimi yok',
    disksTitle: 'Diskler',
    disksSubtitle: "Gözlemlenen blok aygıtları — uzlaştırma turu başına bir tarama; Ceph OSD'si olarak kullanılabilir diskleri burada işaretleyin (N.15: uygunluk açıktır)",
    colDataDisk: 'Veri diski',
    dataDisksHint: "Bir aygıtı işaretlemek onu OSD olarak kullanılabilir bildirir; seri numarası kimlik pin'idir — aygıt bildirdiğinde donanımdan kopyalanır, aksi halde üretilir (tvirt-…). Ceph kayıt dialog'u yalnızca bildirilen diskleri sunar.",
    diskDeclaredSerial: 'bildirildi',
    diskNotObserved: 'bildirildi ama gözlemlenmedi — aygıtı yeniden takın veya işareti kaldırın',
    noDisks: 'Henüz gözlemlenen blok aygıtı yok',
    colSerial: 'Seri numarası',
    colModel: 'Model',
    colSize: 'Boyut (GiB)',
    colDiskType: 'Tür',
    colInUse: 'Kullanımda',
    colObservedAt: 'Gözlemlendi',
    diskInUse: 'kullanımda',
    diskFree: 'boşta',
    diskMounted: 'bağlı',
    diskPartitions: 'bölümler',
    passthroughTitle: 'Passthrough aygıtları',
    passthroughSubtitle: "Gözlemlenen GPU ve USB aygıtları — TVirt'in VM'lere aktarabileceklerini burada işaretleyin; işaretleme aygıtın kimliğini kaydeder (round U1+G1)",
    passthroughHint: "İşaretleme aygıtı kaydeder (kararlı bir id — etiketlerin ve sınıf taleplerinin hedefi). İşaretlenen bir GPU'nun TÜM IOMMU grubu tek seferde vfio-pci'ye bağlanır — host'u hemen terk eder; işaret kaldırılınca yerel driver yeniden bağlanır. USB için ratifiye edilmiş her iki model de vardır: aygıta göre (vendor+ürün, nereye takılırsa takılsın) ve fiziksel porta göre (VM oraya takılı olan her neyse onu alır). USB işaretleme sırasında asla bağlanmaz — takma VM çalışma zamanında gerçekleşir.",
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'TVirt tarafından kullanılabilir',
    colGpu: 'GPU',
    colPciAddress: 'PCI adresi',
    colDriver: 'Driver',
    colVerdict: 'Karar',
    gpuEligible: 'Uygun',
    gpuIneligible: 'Uygun değil',
    gpuReason: {
      'no-iommu': "IOMMU host'ta etkin değil",
      'group-spans-slots': 'IOMMU grubu yalıtılmamış: başka slotlara yayılıyor',
      'multiple-display': 'IOMMU grubu yalıtılmamış: birden fazla görüntü işlevi',
      'foreign-function': 'IOMMU grubu yalıtılmamış: yabancı bir işlev içeriyor'
    },
    vfioNotReady: "IOMMU bu hostta etkin değil: host platformu etkinleştirene kadar (OEM ISO) hiçbir GPU uygun değil — TVirt çalışma zamanında kernel arg'larına asla dokunmaz.",
    vfioMissingKernelArg: "IOMMU bu hostta etkin değil: firmware VT-d/AMD-Vi bildiriyor (ACPI DMAR/IVRS tablosu mevcut) ama kernel arg eksik — kernel komut satırına intel_iommu=on ekleyin (Intel) ya da amd_iommu=off'u kaldırın (AMD) ve yeniden başlatın. TVirt çalışma zamanında kernel arg'larına asla dokunmaz.",
    vfioFirmwareDisabled: "IOMMU bu hostta etkin değil: VT-d/AMD-Vi firmware'de devre dışı (ACPI DMAR/IVRS tablosu yok) ya da CPU desteklemiyor — firmware kurulumundan etkinleştirin, hiçbir kernel arg bunu açamaz. TVirt çalışma zamanında hosta asla dokunmaz.",
    gpuBindError: "{address} üzerinde vfio-pci bind'i başarısız: {error}",

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Yönetilmeyen köprülerde güvenlik duvarı',
    firewallBridgesSubtitle: "Bu düğümde elle kurulmuş, setup'ı takılı konuk NIC'lerinde TVirt'in render ettiği güvenlik duvarı chain'lerine rıza gösteren köprüler",
    firewallBridgesHint: "TVirt yabancı köprüye asla dokunmaz — chain, her zaman TVirt'in kendisine ait olan tap/veth üzerine demirler. Liste bir rıza kapısıdır: default-deny ve anti-spoof, elle yapılmış bir setup'ın beklediğini bozabilir; bu yüzden burada LİSTELENMEMİŞ yönetilmeyen bir köprüdeki güvenlik duvarı taşıyan NIC, konuşan bir hatayla reddedilir.",
    firewallBridgesEmpty: "Bu düğümde TVirt'in render ettiği güvenlik duvarı chain'lerine rıza gösteren yönetilmeyen köprü yok.",
    firewallBridgeAdd: 'Köprü ekle',
    firewallBridgeInvalid: 'Linux arabirim adı değil (1-15 karakter, bölü işareti ve boşluk olmadan)',
    firewallBridgeDuplicate: 'Ad zaten listede',
    colMarkDevice: 'Aygıta göre',
    colMarkPort: 'Porta göre',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'sahipsiz — kayıtlı ama artık algılanmıyor: yeniden takın veya işaretini kaldırın',
    noGpus: 'Henüz gözlemlenen GPU yok',
    noUsb: 'Henüz gözlemlenen USB aygıtı yok',
    networkGeneration: 'Ağ nesli',
    applied: 'Uygulandı',
    converged: 'yakınsamış',
    behind: 'geride — {m} / {n}',
    notConfigured: 'yapılandırılmadı',
    rollbackBody: '{gen} neslinin uygulanması başarısız: {error}',
    rolledBackChip: 'geri alındı',
    nicsTitle: "NIC'ler",
    nicsSubtitle:
      "Yönetilen NIC envanteri — kayıt, yönetim bildiriminin TA KENDİSİDİR: yapılandırması olmayan kayıtlı bir NIC'e dokunulmaz (clear-if onu açıkça temiz bildirir), kayıtsız bir aygıta asla dokunulmaz",
    addNic: 'NIC kaydet',
    addNicTitle: 'NIC kaydet (add-nic)',
    delNic: 'Yönetimi sonlandır',
    delNicTitle: 'Yönetimi sonlandır (del-nic)',
    delNicConfirm:
      "{name} için yönetim sona erer: envanter girdisi ve yapılandırması silinir, TVirt profili kaldırılır — aygıtın kendisi Linux'un bıraktığı gibi kalır.",
    nicName: 'Aygıt adı',
    nicMac: 'Kalıcı MAC adresi',
    nicMacHint: "kalıcı donanım MAC'i — TVirt Server Installer tarafından sabitlenen kararlı kimlik",
    colObserved: 'Gözlemlendi',
    nicObserved: 'gözlemlendi',
    nicNotObserved: 'gözlemlenmedi',
    nicMacMismatch: 'MAC uyuşmuyor — gözlemlenen {mac}',
    noNics: 'Kayıtlı NIC yok — yönetmeye başlamak için bir aygıt kaydedin',
    noManagedDevices: 'Yönetilen aygıt yok — önce bir NIC kaydedin, her şey envanterin üzerine kurulur',
    inventoryTitle: 'Gözlemlenen aygıtlar',
    inventorySubtitle: "Düğüm worker'ı tarafından her uzlaştırma turunda yenilenir — doğrulama, aygıt adlarını bu envantere göre denetler",
    colDevice: 'Aygıt',
    colType: 'Tür',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Hız',
    colTopology: 'Topoloji',
    colMtu: 'MTU',
    colAddresses: 'Adresler',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP toplama yapmıyor',
    noInventory: 'Henüz bildirilen aygıt yok',
    interfacesTitle: 'Arabirimler',
    interfacesSubtitle:
      "Kayıtlı NIC'lerin ve bildirilen mantıksal aygıtların L3 yapılandırması — set-if bloğun tamamını değiştirir, edit-if özelliklere yama uygular, clear-if bloğu boşaltır (açık temizlik)",
    colConfig: 'İstenen yapılandırma',
    clean: 'temiz',
    setIf: 'Adreslemeyi düzenle',
    setIfTitle: 'Adreslemeyi düzenle (set-if)',
    editIf: 'Özellikleri düzenle',
    editIfTitle: 'Özellikleri düzenle (edit-if)',
    clearIf: 'Yapılandırmayı temizle',
    clearIfTitle: 'Yapılandırmayı temizle (clear-if)',
    clearIfConfirm: "Arabirim yapılandırması boşaltılır. Temiz bir arabirim, onu bond/köprü üyesi ya da VLAN parent'ı yapmanın ön koşuludur.",
    ip4Mode: 'IPv4 modu',
    ip6Mode: 'IPv6 modu',
    modeUnconfigured: 'Yapılandırılmadı',
    modeStatic: 'Statik',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 adresleri',
    ip6Addresses: 'IPv6 adresleri',
    addressesHint: 'CIDR, virgülle ayrılmış',
    gw4: 'IPv4 ağ geçidi',
    gw6: 'IPv6 ağ geçidi',
    dns: 'DNS sunucuları',
    dnsHint: "virgülle ayrılmış — boş, DNS'i sıfırlar (set-if bloğu değiştirir)",
    routes4: 'Statik IPv4 rotaları',
    routes6: 'Statik IPv6 rotaları',
    routeTo: 'Hedef (CIDR)',
    routeVia: 'Üzerinden',
    addRoute: 'Rota ekle',
    routesChip: 'rotalar',
    mtu: 'MTU',
    mtuHint: 'boş = driver varsayılanı',
    vlansTitle: "VLAN'lar",
    addVlan: 'VLAN ekle',
    addVlanTitle: 'VLAN ekle (add-vlan)',
    delVlanTitle: 'VLAN sil (del-vlan)',
    vlanParent: 'Parent arabirim',
    vlanId: 'VLAN ID',
    vlanPreview: 'Aygıt adı',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Bildirilen VLAN yok',
    bondsTitle: "Bond'lar",
    addBond: 'Bond ekle',
    addBondTitle: 'Bond ekle (add-bond)',
    editBondTitle: "Bond'u düzenle",
    editBond: "Bond'u kaydet",
    delBondTitle: 'Bond sil (del-bond)',
    bondName: 'Bond adı',
    members: 'Üyeler',
    membersHint: 'üyeler temiz arabirimler olmalıdır (L3 yapılandırması olmadan)',
    bondMode: 'Mod',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Birincil üye',
    rate: 'LACP rate',
    hash: 'İletim hash politikası',
    colMembers: 'Üyeler',
    colMode: 'Mod',
    noBonds: 'Bildirilen bond yok',
    bridgesTitle: 'Köprüler',
    addBridge: 'Köprü ekle',
    addBridgeTitle: 'Köprü ekle (add-bridge)',
    editBridgeTitle: 'Köprüyü düzenle',
    editBridge: 'Köprüyü kaydet',
    delBridgeTitle: 'Köprü sil (del-bridge)',
    bridgeName: 'Köprü adı',
    stp: 'STP',
    stpOn: 'STP açık',
    stpOff: 'STP kapalı',
    colStp: 'STP',
    noBridges: 'Bildirilen köprü yok',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: "Hostname'i ayarla",
    setHostnameTitle: "Hostname'i ayarla (set-hostname)",
    hostnameHint: 'Yalnızca OS kimliği — kümedeki düğüm adına dokunulmaz',
    notSet: 'ayarlanmadı',
    staticHostsTitle: 'Statik host girdileri',
    addStaticHost: 'Girdi ekle',
    addStaticHostTitle: 'Statik host girdisi ekle',
    delStaticHostTitle: 'Statik host girdisini sil',
    hostIp: 'IP adresi',
    hostNames: 'Adlar',
    hostNamesHint: 'virgül veya boşlukla ayrılmış',
    colIp: 'IP',
    colNames: 'Adlar',
    noStaticHosts: 'Statik host girdisi yok',
    delConfirm: "{name} istenen belgeden kaldırılıyor — düğüm worker'ı NetworkManager checkpoint'i ve otomatik geri alma ile yakınsar.",
    remove: 'Kaldır',
    opError: 'Ağ işlemi reddedildi'
  }
}
